// extracted by extract-css-chunks-webpack-plugin
module.exports = {"aligned":"_21o7r-","grid":"ki2so8","centered-section-spacing":"_2ACUNV","grid-odd":"_3vSHOu","boxTextContainer":"VF8m8t","boxTextBox":"kwNgRV","boxTextTitle":"_3VYcfW"};